"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("../Util/Icon"));
const __1 = require("../..");
const Journey_1 = require("../../lib/Journey");
const SelectButtonCaret = (props) => react_1.default.createElement(Icon_1.default, Object.assign({}, props, { src: Journey_1.Journey.icons().CARET_DOWN }));
exports.default = __1.withJourney('j-select-button-caret', SelectButtonCaret);
